var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDbApplication(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.512 0.196969C17.867 0.443011 18.0534 0.868314 17.9866 1.29362L15.7365 15.9156C15.6838 16.2565 15.4764 16.5553 15.174 16.724C14.8717 16.8927 14.5096 16.9138 14.1896 16.7802L9.98489 15.0333L7.57665 17.6379C7.26376 17.9788 6.77156 18.0913 6.33914 17.9226C5.90671 17.7539 5.62545 17.3356 5.62545 16.8716V13.9332C5.62545 13.7926 5.67819 13.659 5.77311 13.5571L11.6654 7.12834C11.8693 6.90691 11.8623 6.56596 11.6513 6.35507C11.4404 6.14417 11.0994 6.13011 10.8779 6.33046L3.72699 12.6819L0.622641 11.1283C0.249979 10.942 0.0109132 10.5694 0.000366177 10.1547C-0.0101809 9.73991 0.207791 9.35327 0.566391 9.1459L16.3166 0.14776C16.6928 -0.0666486 17.1569 -0.0455593 17.512 0.196969Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbApplication);
export default __webpack_public_path__ + "static/media/db-application.ea780176142b35f588e63eb5ff742884.svg";
export { ForwardRef as ReactComponent };